import React from "react"
import TableRow from "material-ui/Table/TableRow"
import EmployeeTimecardTableDay from "./EmployeeTimecardTableDay"
import * as timecardHelper from "../../helpers/timecardHelper"
import { IJobStatusData, ITimecardDay, IObjectTimecardDocument, IPayrollStatusDocument, ITimecardEmployee, ISuspensePunchData, IPunchSetDocument, ICommentData } from "../../models"
interface IProps {
    timecardDays: ITimecardDay[]
    readonly: boolean
    hierarchyItemId: string
    jobId: string
    phaseId: string
    positionId: string
    user: ITimecardEmployee
    timecard: IObjectTimecardDocument
    lockData: IPayrollStatusDocument[]
    suspensePunchData: ISuspensePunchData
    jobStatusData: IJobStatusData[]
    commentData: ICommentData[]
    addPunch(timecardDay: ITimecardDay, user: ITimecardEmployee, timecard: IObjectTimecardDocument, hierarchyItemId: string, positionId: string, payClassId: string, payTypeId: string, jobId: string, shiftId: string, breakId: string, mobileBreakId: string, phaseId: string, equipmentId: string, isPunchIn: boolean, pairedPunchId: string): void
    onTimeChange(punchId: string, dateTime: Date | string, errorCb: () => void): void
    onConfirmDelete(punchId: string): void
    reloadTimecard(msg: string): void
    handleApprovePunchSet(status: "unapprove" | "approve", punchSet: IPunchSetDocument): void

    //we need to select hierarchy based on employee punch permission, not logged in user punch permission (when the user has more punch rights than the admin)
    //it's possible when full timecard, for example, employee->timecard and payroll->timecard
    //timecards page is not full timecard in the case filter by punch level
    isFullTimecard?: boolean

    priorPeriodAdjustMode: boolean
    allowPriorPeriodAdjust: boolean
    originalTimecard: boolean

    virtualTimecard: boolean
    showTimecardDetails: boolean
}

const EmployeeTimecardTableRow: React.SFC<IProps> = (props: IProps) => {
    const addPunch = (timecardDay, hierarchyItemId, positionId, payClassId, payTypeId, shiftId, breakId, mobileBreakId, jobId, phaseId, equipmentId, isPunchIn, pairedPunchId) => {
        props.addPunch &&
            props.addPunch(timecardDay, props.user, props.timecard, hierarchyItemId, positionId, payClassId, payTypeId, shiftId, breakId, mobileBreakId, jobId, phaseId, equipmentId, isPunchIn, pairedPunchId)
    }

    const onTimeChange = (punchId, dateTime, errorCb: () => void) => {
        props.onTimeChange &&
            props.onTimeChange(punchId, dateTime, errorCb)
    }

    const onConfirmDelete = (punchId) => {
        props.onConfirmDelete &&
            props.onConfirmDelete(punchId)
    }

    return (
        <TableRow className="EmployeeTimecardTableRow">
            {props.timecardDays.map((timecardDay, index) => {
                const locked = timecardHelper.timecardDayLocked(props.user.Id, timecardDay.LocalStartDayTime, props.lockData, props.priorPeriodAdjustMode, props.allowPriorPeriodAdjust)

                return (
                    <EmployeeTimecardTableDay
                        fullPunchSets={props.timecard.MasterTimecard.FullPunchSets}
                        day={timecardDay}
                        key={index}
                        user={props.user}
                        addPunch={addPunch}
                        onTimeChange={onTimeChange}
                        onConfirmDelete={onConfirmDelete}
                        timecardLocked={locked}
                        readonly={props.readonly}
                        hierarchyItemId={props.hierarchyItemId}
                        jobId={props.jobId}
                        phaseId={props.phaseId}
                        positionId={props.positionId}
                        reloadTimecard={props.reloadTimecard}
                        isFullTimecard={props.isFullTimecard}
                        allowPriorPeriodAdjust={props.allowPriorPeriodAdjust}
                        suspensePunchData={props.suspensePunchData}
                        jobStatusData={props.jobStatusData}
                        commentData={props.commentData}
                        virtualTimecard={props.virtualTimecard}
                        priorPeriodAdjustMode={props.priorPeriodAdjustMode}
                        originalTimecard={props.originalTimecard}
                        handleApprovePunchSet={props.handleApprovePunchSet}
                        showTimecardDetails={props.showTimecardDetails}
                    />
                )
            })}
        </TableRow>
    )
}

export default EmployeeTimecardTableRow
